import { createFileRoute } from '@tanstack/react-router';
import { StaffingBrowsePage } from '@/pages/staffing/StaffingBrowsePage';
import { NORWEGIAN_COUNTY_VALUES } from '@/pages/staffing/norwegian-counties';
import { z } from 'zod';

const staffingBrowseSearchSchema = z.object({
	categoryIds: z.array(z.string()).optional(),
	counties: z.array(z.enum(NORWEGIAN_COUNTY_VALUES)).optional(),
	skillLevelId: z.string().optional(),
	status: z.enum(['ACTIVE', 'CLOSED', 'EXPIRED']).optional(),
	skills: z.array(z.string()).optional(),
	dateFrom: z.string().optional(),
	dateTo: z.string().optional(),
	search: z.string().optional(),
	bookmarked: z.boolean().optional(),
	page: z.coerce.number().int().positive().optional(),
	limit: z.coerce.number().int().positive().optional(),
	view: z.enum(['card', 'list']).optional(),
});

export const Route = createFileRoute('/_authenticated/_app/staffing/')({
	component: StaffingBrowsePage,
	validateSearch: staffingBrowseSearchSchema,
});
